/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import classNames from 'classnames';
import * as React from 'react';

import { mapToCssModules } from '../common/utilities';
import { IPaginationProps } from './Pagination.props';

/**
 * Pagination component.
 */
export default class Pagination extends React.PureComponent<IPaginationProps> {
    public static defaultProps: Partial<IPaginationProps> = {
        tag: 'nav',
        listTag: 'ul',
        'aria-label': 'pagination'
    };

    public render(): JSX.Element {
        /* eslint-disable @typescript-eslint/no-explicit-any */
        const {
            className,
            listClassName,
            cssModule,
            size,
            tag: Tag,
            listTag: ListTag,
            'aria-label': label,
            role,
            ...props
        }: any = this.props;

        const paginationClasses = mapToCssModules(classNames(className), cssModule);

        const listpaginationClasses = mapToCssModules(
            classNames(listClassName, 'msc-pagination', {
                [`msc-pagination-${size}`]: !!size
            }),
            cssModule
        );

        return (
            <Tag className={paginationClasses} role="navigation" aria-label={label}>
                <ListTag {...props} className={listpaginationClasses} />
            </Tag>
        );
    }
}
